export default __webpack_public_path__ + "static/media/221.a7980f26.jpg";